(function () {
  var STORAGE_KEY = 'shopify_selected_variant';

  document.addEventListener('DOMContentLoaded', function () {
    initVariantSelectors();
    initProductPagePreselect();
    attachProductLinkVariantParam();
    initVariantImageSwitching();
  });

  // Initialize variant button clicks
  function initVariantSelectors() {
    var buttons = document.querySelectorAll('.variant-images__button');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent any bubbling
        selectVariant(this);
      });
    });
    // Restore any previously selected variants from sessionStorage
    try {
      var stored = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      Object.keys(stored).forEach(function (productId) {
        var variantId = stored[productId] && stored[productId].variantId;
        if (!variantId) return;
        var container = document.querySelector('.card__variant-images[data-product-id="' + productId + '"]');
        if (!container) return;
        var btn = container.querySelector('.variant-images__button[data-variant-id="' + variantId + '"]');
        if (btn) {
          btn.classList.add('active');
          btn.setAttribute('aria-pressed', 'true');
        }
      });
    } catch (e) {
      // ignore
    }
  }

  // Initialize image switching for variant selection
  function initVariantImageSwitching() {
    // Listen for swatch/variant input changes on product page
    var variantInputs = document.querySelectorAll('input[name^="options["], input[data-option-position]');
    variantInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        switchVariantImage(this);
      });
    });

    // Also handle dropdown changes
    var selects = document.querySelectorAll('select[name^="options["]');
    selects.forEach(function (select) {
      select.addEventListener('change', function () {
        switchVariantImage(this);
      });
    });
  }

  // Switch product image based on selected variant
  function switchVariantImage(input) {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    // Get variant data from the page
    var variantsScript = document.querySelector('script[data-product-variants]');
    if (!variantsScript) return;

    try {
      var allVariants = JSON.parse(variantsScript.textContent);
      if (!Array.isArray(allVariants)) return;

      // Find the matching variant by checking all options
      var matchingVariant = null;
      
      // Get all selected option values
      var selectedOptionValues = {};
      var allInputs = document.querySelectorAll('input[name^="options["], input[data-option-position]');
      allInputs.forEach(function (inp) {
        if (inp.checked) {
          var optionName = inp.getAttribute('name') || inp.getAttribute('data-option-position');
          if (optionName) {
            optionName = optionName.replace('options[', '').replace(']', '');
            selectedOptionValues[optionName] = inp.value;
          }
        }
      });

      // Also check select elements
      var selects = document.querySelectorAll('select[name^="options["]');
      selects.forEach(function (sel) {
        var optionName = sel.getAttribute('name').replace('options[', '').replace(']', '');
        selectedOptionValues[optionName] = sel.value;
      });

      // Find variant that matches all selected options
      matchingVariant = allVariants.find(function (variant) {
        var matches = true;
        for (var optName in selectedOptionValues) {
          // Check if variant has an option that matches
          if (!variant.title || !variant.title.includes(selectedOptionValues[optName])) {
            // Try checking option fields directly
            var found = false;
            for (var i = 1; i <= 3; i++) {
              var optKey = 'option' + i;
              if (variant[optKey] === selectedOptionValues[optName]) {
                found = true;
                break;
              }
            }
            if (!found) {
              matches = false;
              break;
            }
          }
        }
        return matches;
      });

      if (matchingVariant && matchingVariant.featured_image) {
        updateProductImage(matchingVariant.featured_image.src || matchingVariant.featured_image);
      }
    } catch (e) {
      console.warn('Could not switch variant image:', e);
    }
  }

  // Update product image on page
  function updateProductImage(imageUrl) {
    if (!imageUrl) return;

    // Ensure we have a proper URL
    if (typeof imageUrl === 'object' && imageUrl.src) {
      imageUrl = imageUrl.src;
    }

    // Find all product images that might need updating
    var images = document.querySelectorAll('product-media-gallery img, [role="img"] img, .product__media img');
    
    if (images.length === 0) {
      // Try finding by more specific selectors
      images = document.querySelectorAll('img[alt*="product"], img[alt*="featured"]');
    }

    var processed = false;
    images.forEach(function (img, index) {
      if (!processed || index === 0) {
        // Get the base URL without query params
        var baseUrl = imageUrl.split('?')[0];
        
        // Update the main product image (usually first one)
        if (index === 0) {
          img.src = baseUrl;
          
          // Update srcset if it exists
          if (img.srcset) {
            img.srcset = baseUrl + ' 1x, ' + baseUrl + ' 2x';
          }
          
          // Update data attributes if they exist
          if (img.dataset.src) {
            img.dataset.src = baseUrl;
          }
          
          processed = true;
        }
      }
    });
  }

  // Select a variant and store it
  function selectVariant(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    var variantTitle = btn.getAttribute('data-variant-title');
    var productId = btn.closest('.card__variant-images').getAttribute('data-product-id');

    if (!variantId || !productId) return;

    // Update visual state - remove active from all in this container
    var container = btn.closest('.card__variant-images');
    container.querySelectorAll('.variant-images__button').forEach(function (b) {
      b.classList.remove('active');
      b.setAttribute('aria-pressed', 'false');
    });
    btn.classList.add('active');
    btn.setAttribute('aria-pressed', 'true');

    // Store in sessionStorage
    try {
      var data = {};
      data[productId] = {
        variantId: variantId,
        variantTitle: variantTitle,
        timestamp: new Date().getTime()
      };
      var existing = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      Object.assign(existing, data);
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(existing));
    } catch (e) {
      console.error('Error saving variant selection', e);
    }
  }

  // Auto-select first available variant on page load
  function autoSelectFirstVariant() {
    var variantContainers = document.querySelectorAll('.card__variant-images');
    variantContainers.forEach(function (container) {
      var firstBtn = container.querySelector('.variant-images__button:first-child');
      if (firstBtn) {
        firstBtn.classList.add('active');
        var variantId = firstBtn.getAttribute('data-variant-id');
        var productId = container.getAttribute('data-product-id');
        
        // Store selection
        selectVariant(firstBtn);
      }
    });
  }

  // On product page, pre-select the variant from sessionStorage or URL
  function initProductPagePreselect() {
    var productInfo = document.querySelector('product-info');
    if (!productInfo) return;

    var productId = productInfo.getAttribute('data-product-id');
    if (!productId) return;

    // Check URL for variant param first
    var urlParams = new URLSearchParams(window.location.search);
    var variantIdToSelect = urlParams.get('variant');
    var variantOptionsToSelect = urlParams.get('variant_options');

    // If no URL param, check sessionStorage for card variant selection
    if (!variantIdToSelect && !variantOptionsToSelect) {
      try {
        // Check for card variant selection from card-product-variants.js
        if (window.getCardVariantSelection) {
          var cardSelection = window.getCardVariantSelection(productId);
          if (cardSelection) {
            variantOptionsToSelect = JSON.stringify(cardSelection);
          }
        }
        // Also check for the full stored entry to get variantId
        if (window.getCardVariantSelectionEntry) {
          var cardEntry = window.getCardVariantSelectionEntry(productId);
          if (cardEntry && cardEntry.variantId) {
            variantIdToSelect = cardEntry.variantId;
          }
        }
        
        // Also check old storage key for backward compatibility
        var storedData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
        if (storedData[productId] && storedData[productId].variantId) {
          variantIdToSelect = storedData[productId].variantId;
        }
      } catch (e) {
        console.error('Error reading variant selection', e);
      }
    }

    // If we have variant options from the card, select them
    if (variantOptionsToSelect) {
      try {
        var options = JSON.parse(decodeURIComponent(variantOptionsToSelect));
        selectVariantsByOptions(options);
        cleanupSessionStorage(productId);
        return;
      } catch (e) {
        console.error('Error parsing variant options:', e);
      }
    }

    if (!variantIdToSelect) return;

    // Try to set the variant in the product form by ID
    var attempts = 0;
    var maxAttempts = 30;
    var selectVariantInterval = setInterval(function () {
      attempts++;

      // Look for select with name="id"
      var variantSelect = document.querySelector('select[name="id"]');
      if (variantSelect) {
        var option = variantSelect.querySelector('option[value="' + variantIdToSelect + '"]');
        if (option) {
          variantSelect.value = variantIdToSelect;
          var changeEvent = new Event('change', { bubbles: true });
          variantSelect.dispatchEvent(changeEvent);
          clearInterval(selectVariantInterval);
          // Clean up sessionStorage
          cleanupSessionStorage(productId);
          // Mark the corresponding product label/input as selected for visual sync
          try {
            var foundEl = document.querySelector('[data-variant-id="' + variantIdToSelect + '"]') || document.querySelector('input[value="' + variantIdToSelect + '"]');
            if (foundEl) {
              var lab = foundEl.closest('label') || document.querySelector('label[for="' + (foundEl.id || '') + '"]');
              if (lab) {
                // remove is-selected from siblings
                var groupName = foundEl.getAttribute('data-option-position') || foundEl.getAttribute('name');
                if (groupName) {
                  document.querySelectorAll('input[data-option-position="' + (foundEl.getAttribute('data-option-position') || '') + '"]').forEach(function (el) {
                    var l = el.closest('label') || document.querySelector('label[for="' + (el.id || '') + '"]');
                    if (l) l.classList.remove('is-selected');
                  });
                }
                lab.classList.add('is-selected');
              }
            }
          } catch (e) {}
          return;
        }
      }

      // Look for swatch/variant input elements
      // First try to find input with explicit data-variant-id attribute
      var variantInput = document.querySelector('input[data-variant-id="' + variantIdToSelect + '"]');
      // Fallback: try finding by value if data-variant-id didn't work
      if (!variantInput) {
        variantInput = document.querySelector('input[name*="option"][value="' + variantIdToSelect + '"]');
      }
      if (variantInput) {
        variantInput.click();
        // mark its label as selected
        try {
          var lab2 = variantInput.closest('label') || document.querySelector('label[for="' + (variantInput.id || '') + '"]');
          if (lab2) {
            // remove from siblings
            var pos = variantInput.getAttribute('data-option-position');
            if (pos) {
              document.querySelectorAll('input[data-option-position="' + pos + '"]').forEach(function (el) {
                var l = el.closest('label') || document.querySelector('label[for="' + (el.id || '') + '"]');
                if (l) l.classList.remove('is-selected');
              });
            }
            lab2.classList.add('is-selected');
          }
        } catch (e) {}
        clearInterval(selectVariantInterval);
        cleanupSessionStorage(productId);
        return;
      }

      if (attempts >= maxAttempts) {
        clearInterval(selectVariantInterval);
        cleanupSessionStorage(productId);
      }
    }, 100);
  }

  // Select variant by option values
  function selectVariantsByOptions(options) {
    var attempts = 0;
    var maxAttempts = 50;
    
    var selectInterval = setInterval(function () {
      attempts++;
      var allSelected = true;
      
      // Find variant-selects component
      var variantSelects = document.querySelector('variant-selects');
      if (!variantSelects && attempts < maxAttempts) return;
      
      Object.keys(options).forEach(function (optionPosition) {
        var optionValue = options[optionPosition];
        
        // Try to find by name="options[OptionName]" pattern
        var found = false;
        
        // First try radio inputs with data-option-value
        var inputs = document.querySelectorAll('input[type="radio"][data-option-value="' + optionValue + '"]');
        if (inputs.length > 0) {
          inputs.forEach(function (input) {
            if (!input.checked) {
              input.checked = true;
              // Dispatch change on the variant-selects container
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            // mark product swatch visually
            markProductInputSelected(input);
            found = true;
          });
        }
        
        // Try option-position match
        if (!found) {
          var positionInputs = document.querySelectorAll('input[data-option-position="' + optionPosition + '"][value="' + optionValue + '"]');
          positionInputs.forEach(function (input) {
            if (!input.checked) {
              input.checked = true;
              input.dispatchEvent(new Event('change', { bubbles: true }));
            }
            markProductInputSelected(input);
            found = true;
          });
        }
        
        // Try selects with option names
        if (!found) {
          var selects = document.querySelectorAll('select');
          selects.forEach(function (select) {
            var option = select.querySelector('option[value="' + optionValue + '"]');
            if (option) {
              select.value = optionValue;
              select.dispatchEvent(new Event('change', { bubbles: true }));
              // try to find an input corresponding to this select option and mark it
              var matchingInput = document.querySelector('input[value="' + optionValue + '"]');
              if (matchingInput) markProductInputSelected(matchingInput);
              found = true;
            }
          });
        }
        
        if (!found && attempts >= maxAttempts) allSelected = false;
      });
      
      if (allSelected || attempts >= maxAttempts) {
        clearInterval(selectInterval);
      }
    }, 100);
  }

  // Mark the product page swatch/input label as selected for visual sync
  function markProductInputSelected(input) {
    if (!input) return;

    // Group selector: prefer data-option-position, fallback to name
    var pos = input.getAttribute('data-option-position');
    var name = input.getAttribute('name');
    var selector = null;
    if (pos) selector = 'input[data-option-position="' + pos + '"]';
    else if (name) selector = 'input[name="' + name + '"]';

    if (selector) {
      document.querySelectorAll(selector).forEach(function (el) {
        var lab = el.closest('label') || document.querySelector('label[for="' + (el.id || '') + '"]');
        if (lab) lab.classList.remove('is-selected');
        // also remove from swatch-input labels if present
        var swatchLab = el.closest('label') || document.querySelector('label[for="' + (el.id || '') + '"]');
        if (swatchLab && swatchLab.classList.contains('swatch-input__label')) swatchLab.classList.remove('is-selected');
      });
    }

    var myLab = input.closest('label') || document.querySelector('label[for="' + (input.id || '') + '"]');
    if (myLab) myLab.classList.add('is-selected');
    // also add to swatch-input label variant if applicable
    if (myLab && myLab.classList.contains('swatch-input__label')) myLab.classList.add('is-selected');
  }

  // Clean up sessionStorage after use
  function cleanupSessionStorage(productId) {
    try {
      var storedData = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      delete storedData[productId];
      if (Object.keys(storedData).length === 0) {
        sessionStorage.removeItem(STORAGE_KEY);
      } else {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(storedData));
      }
    } catch (e) {
      // ignore
    }
  }

  // Add variant param to product title link when clicked
  function attachProductLinkVariantParam() {
    var productCards = document.querySelectorAll('.card-wrapper');
    productCards.forEach(function (card) {
      var variantContainer = card.querySelector('.card__variant-images');
      if (!variantContainer) return;

      var productId = variantContainer.getAttribute('data-product-id');
      var productLink = card.querySelector('a.full-unstyled-link[href*="/products/"]');
      
      if (productLink) {
        productLink.addEventListener('click', function (e) {
          var activeBtn = variantContainer.querySelector('.variant-images__button.active');
          if (activeBtn) {
            var variantId = activeBtn.getAttribute('data-variant-id');
            if (variantId) {
              var href = productLink.getAttribute('href');
              // Remove any existing variant param
              href = href.split('?')[0];
              // Set new href with variant
              productLink.setAttribute('href', href + '?variant=' + variantId);
            }
          }
        });
      }
    });
  }
})();
